import React from "react";
import { ReactComponent as ForwardIconSVG } from "../../build/images/forward.svg";

const ForwardIcon = ({ handleDirectForward }) => {
  return (
    <div className="forward-icon" onClick={handleDirectForward}>
      <ForwardIconSVG />
    </div>
  );
};

export default ForwardIcon;
